<template>
  <span>
    <label class="page-label">Link HLS</label>

    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;"> {{ $t('message.pages.videosDataTable.menu.copyHLS')}} </p>

    <v-text-field v-model="streamHls" :placeholder="$t('message.pages.newLive.streamUrl')" class="mb-3" outlined dense
      hide-details readonly>
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="primary" @click="handleShowLink(streamHls)">
              mdi-content-copy
            </v-icon>
          </template>
          <span>{{
            $t('message.pages.videoEditModal.copyToClipboard')
          }}</span>
        </v-tooltip>
      </template>
    </v-text-field>


  </span>
</template>

<script>
// external imports

import { mapMutations } from 'vuex'

// internal imports

// API

// Components

export default {
  name: 'LiveLink',

  props: {
    propsData: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    form: {
      disabled: true,
    },
  }),
  computed: {
    streamHls: {
      get() { return this.propsData['streamHls'] },
      set(value) { this.propsData['streamHls'] = value }
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleShowLink(value) {
      const i18n = this.$i18next
      let text = 'Error trying coping this. Please coping directly from field'

      if (navigator && navigator.clipboard) {
        text = i18n.t('message.copiedToClipboard')
        navigator.clipboard.writeText(`${value}`)
      }

      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {
  .new-live-embed {
    background-color: var(--v-neutral-darken2);
    color: white;
  }

  .page-label {
    color: var(--v-primary-base) !important
  }
}
</style>
